import produce from 'immer';
import { ALLOWED_TO_SHARE_LOCATION } from '../constants/actions/sharedActions';
import ISharedReducer from '../interfaces/reducers/sharedReducer';

const initialValues: ISharedReducer = {
	userHasAllowedToShareLocation: false,
};

const sharedReducer = produce((draft: ISharedReducer, action) => {
	switch (action.type) {
		case ALLOWED_TO_SHARE_LOCATION: {
			draft.userHasAllowedToShareLocation = action.payload.userHasAllowedToShareLocation;
			break;
		}
		default: {
			break;
		}
	}
}, initialValues);

export default sharedReducer;
